var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 66,
    viewBox: "0 0 63 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "#F3F4F6",
    stroke: "#D1D5DB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 54,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.25 54C41.25 48.6152 45.6152 44.25 51 44.25C56.3848 44.25 60.75 48.6152 60.75 54C60.75 59.3848 56.3848 63.75 51 63.75C45.6152 63.75 41.25 59.3848 41.25 54ZM51 50.25C51.4142 50.25 51.75 50.5858 51.75 51V54.75C51.75 55.1642 51.4142 55.5 51 55.5C50.5858 55.5 50.25 55.1642 50.25 54.75V51C50.25 50.5858 50.5858 50.25 51 50.25ZM51 58.5C51.4142 58.5 51.75 58.1642 51.75 57.75C51.75 57.3358 51.4142 57 51 57C50.5858 57 50.25 57.3358 50.25 57.75C50.25 58.1642 50.5858 58.5 51 58.5Z",
    fill: "#F05252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3176 28.0005L34.7724 40.0001M27.2276 40.0001L26.6824 28.0005M42.3896 23.7206C42.9285 23.7899 43.4642 23.8632 44 23.9419M42.3896 23.7219L40.7067 42.2307C40.638 42.9844 40.2356 43.6883 39.58 44.2017C38.9244 44.7151 38.064 45.0002 37.1707 45H24.8293C23.936 45.0002 23.0756 44.7151 22.42 44.2017C21.7644 43.6883 21.362 42.9844 21.2933 42.2307L19.6104 23.7206M42.3896 23.7206C40.5709 23.4879 38.7429 23.3114 36.9091 23.1912M18 23.9406C18.5358 23.8619 19.0715 23.7886 19.6104 23.7206M19.6104 23.7206C21.4291 23.4879 23.2571 23.3114 25.0909 23.1912M36.9091 23.1912V21.9699C36.9091 20.3967 35.4752 19.0847 33.6158 19.0354C31.8724 18.9882 30.1276 18.9882 28.3842 19.0354C26.5248 19.0847 25.0909 20.398 25.0909 21.9699V23.1912M36.9091 23.1912C32.9756 22.934 29.0244 22.934 25.0909 23.1912",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAlert);
export default __webpack_public_path__ + "static/media/delete-alert.1ece57f6359c3b086aeb0aec1745dad2.svg";
export { ForwardRef as ReactComponent };